import { TableHeader } from '@tiptap/extension-table-header';

export const LetTableHeader = TableHeader.extend({
  allowGapCursor: true,
  addAttributes() {
    return {
      colspan: {
        default: 1,
        renderHTML: (attributes) => {
          if (attributes.colspan > 1)
            return {
              colspan: attributes.colspan,
            };
        },
      },
      rowspan: {
        default: 1,
        renderHTML: (attributes) => {
          if (attributes.rowspan > 1)
            return {
              rowspan: attributes.rowspan,
            };
        },
      },

      colwidth: {
        default: null,
        parseHTML: (element) => {
          const colwidth = element.getAttribute('colwidth');
          return colwidth ? [parseInt(colwidth, 10)] : null;
        },
        renderHTML: () => {
          return {};
        },
      },

      width: {
        default: null,
        // Customize the HTML parsing
        parseHTML: (element) => element.getAttribute('width'),
        // … and customize the HTML rendering
        renderHTML: (attributes) => {
          return {
            width: attributes.width,
          };
        },
      },
    };
  },
});
